import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';
import { CredentialRevocationLog } from '../../models/credential-revocation-log';

@Injectable({ providedIn: 'root' })
export class CredentialRevocationService {
    private baseUrl = 'api/credentials';

    constructor(private apiService: ApiService) {}

    revoke(inviteId: number, reason: number, reasonText?: string): Promise<any> {
        return this.apiService.post(`${this.baseUrl}/${inviteId}/revoke`, { reason, reasonText });
    }

    reactivate(inviteId: number): Promise<any> {
        return this.apiService.post(`${this.baseUrl}/${inviteId}/reactivate`, {});
    }

    getHistory(inviteId: number): Promise<CredentialRevocationLog[]> {
        return this.apiService.get<CredentialRevocationLog[]>(`${this.baseUrl}/${inviteId}/history`);
    }
}
